import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { CustomValidators } from '@se-po/shared-data-access-validators'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form">
    <se-po-dob-select
      formControlName="dateOfBirth"
      seFeDataLabel="Date of Birth">
    </se-po-dob-select>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { CustomValidators } from '@se-po/shared-data-access-validators'

export class AgeCheckDobSelectExampleComponent implements OnInit {
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) {
    super()
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      dateOfBirth: ['']
    })
  }
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-age-check-dob-select-example',
  template,
  styleUrls: ['../dob-select-docs.component.scss'],
  standalone: false,
})
export class AgeCheckDobSelectExampleComponent extends SeFeDocsExampleComponent implements OnInit {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public form: UntypedFormGroup

  constructor(
    private fb: FormBuilder
  ) {
    super()
  }

  public ngOnInit(): void {
    this.form = this.fb.group({
      dateOfBirth: ['', [
        CustomValidators.dobValid,
        CustomValidators.dob13,
      ]]
    })
  }
}
